/**
 * Утилиты для работы с маршрутами
 * Pure functions - не имеют побочных эффектов
 */

/**
 * Проверяет, является ли текущий маршрут одним из указанных
 * @param {string|Object} route - Маршрут (имя или объект маршрута)
 * @param {string[]} routeNames - Массив имен маршрутов для проверки
 * @returns {boolean} - true если маршрут совпадает с одним из указанных
 */
export function isRouteInList(route, routeNames) {
  if (!route || !Array.isArray(routeNames) || routeNames.length === 0) {
    return false
  }
  
  const routeName = typeof route === 'string' ? route : route?.name
  if (!routeName) {
    return false
  }
  
  return routeNames.includes(routeName)
}
